import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import {
  RoundArrowLeftButton,
  RoundArrowRightButton,
} from "../../assets/images/svg/svg";
import "react-tooltip/dist/react-tooltip.css";
import "./index.scss";
import { getRenewalTitle } from "../../service/renewal/renewalService";

function Testimonials({ fetchData, title }) {
  const [testimonialsData, setTestimonialsData] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      const data = await fetchData();
      setTestimonialsData(data?.testimonials?.data);
    };
    fetchTestimonials();
  }, []);

  const sliderRef = useRef(null);

  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        },
      },

      {
        breakpoint: 920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
    ],
  };

  const slideLeft = () => {
    sliderRef.current.slickPrev();
  };

  const slideRight = () => {
    sliderRef.current.slickNext();
  };

  useEffect(() => {
    const getTitles = async () => {
      await getRenewalTitle();
    };
    getTitles();
  }, []);

  return (
    <div>
      <div className="testimonials-container">
        <div className="testimonials-header">
          <h3>{title}</h3>
          <div className="arrow-button-container">
            <button className="arrow-button-left" onClick={slideLeft}>
              <RoundArrowLeftButton />
            </button>
            <button className="arrow-button-left" onClick={slideRight}>
              <RoundArrowRightButton />
            </button>
          </div>
        </div>
        <div className="testimonials-cards">
          <Slider ref={sliderRef} {...settings}>
            {testimonialsData?.map((test, ind) => {
              const description = test?.attributes?.description || "";
              const words = description.split(" ");
              const truncatedDescription =
                words.length > 22
                  ? words.slice(0, 22).join(" ") + "..."
                  : description;
              const tooltipContent =
                words.length > 22 ? words.slice(22).join(" ") : "";

              return (
                <div className="cards-container" key={ind}>
                  <div className="card-testimonials">
                    <div className="upper-card">
                      <div className="header--avatar">
                        <img
                          src={
                            test.attributes?.profilePicture?.data?.attributes
                              ?.url
                          }
                          alt=""
                        />
                      </div>
                      <div className="upper-card-desc">
                        <h5>{test?.attributes?.title}</h5>
                        <p>{test?.attributes?.designation}</p>
                      </div>
                    </div>
                    <a
                      data-tooltip-id={`tooltip-${ind}`}
                      data-tooltip-content={tooltipContent}
                      data-tooltip-place="bottom"
                    >
                      {truncatedDescription}
                    </a>
                    {words.length > 22 && (
                      <Tooltip id={`tooltip-${ind}`} place="bottom-start" />
                    )}
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
